import axios from "../axios/axios";
import { setWarehouses } from "../store/actions/warehouseAction";
import { appCloseModal, appSetAlert, appSetLoading, appSetSendingRequest } from "../store/actions/appAction";
import { apiSetAlert } from "./appApi";
import { resetForm, setAction, setEditItem, setIndex, updateFormStatus } from "../store/actions/formAction";
import { setWarehouseFormData } from "../helpers/FormDataCreator";
import { errorDispatcher, getOptionsQuery, setSelectItemLabels } from "../helpers";
import fileDownload from "js-file-download";
import { setTableData } from "../store/actions/dataTableAction";
import { DateToString } from "components/Reports/DateFilter";

export const apiGetWarehousesExcel = (token, type, selectedIds) => (dispatch, getState) => {
  let url = "warehouses/excel/export";
  if (selectedIds) {
    url += `?ids=[${selectedIds}]`;
  }
  dispatch(appSetLoading());
  axios
    .get(url, {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "blob",
    })
    .then((response) => {
      dispatch(appSetLoading(false));
      const now = DateToString(Date.now()).replace("/", "_");
      fileDownload(response.data, `warehouses_${now}.xlsx`);
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiGetWarehouse = (warehouseId, token) => (dispatch, getState) => {
  dispatch(appSetLoading());
  axios
    .get(`warehouses/${warehouseId}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      dispatch(setEditItem(response.data.warehouse));
      dispatch(appSetLoading(false));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiGetWarehouses = (withoutLoading, cb, filterWarehouse) => (dispatch, getState) => {
  const Token = getState().businessReducer.business?.token;
  let url = `warehouses`
  if (filterWarehouse && filterWarehouse === "allWarehouse") {
    url += `?filter=${filterWarehouse}`
  }
  if (!withoutLoading)
    dispatch(appSetLoading(true));
  axios
    .get(url, {
      headers: { Authorization: `Bearer ${Token}` },
    })
    .then((response) => {
      const warehouses = setSelectItemLabels(response.data.warehouses, "id", "title");
      dispatch(setWarehouses(warehouses));
      if (!withoutLoading) dispatch(appSetLoading(false));
      cb && cb(response, warehouses);
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiDeleteWarehouse = (warehouseId, token) => (dispatch, getState) => {
  dispatch(appSetLoading());
  axios
    .delete(`/warehouses/${warehouseId}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      dispatch(apiGetWarehouses(token));
      dispatch(apiSetAlert(response.data.message, "success"));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiAddWarehouses = (forms, token, navigate, modalProps) => (dispatch, getState) => {
  dispatch(appSetSendingRequest(true));
  dispatch(setAction("save"));
  apiAddWarehouse(dispatch, forms, token, 0, navigate, modalProps);
};

export const apiAddWarehouse = (dispatch, forms, token, index, navigate, modalProps, errorIndex = null) => {
  const form = forms[index];

  const nextApi = (res) => {
    if (index + 1 < forms.length) {
      apiAddWarehouse(dispatch, forms, token, index + 1, navigate, modalProps, errorIndex);
    } else {
      dispatch(appSetSendingRequest(false));
      if (errorIndex !== null) {
        dispatch(setAction("filling"));
        dispatch(apiSetAlert(forms[errorIndex].errors, "error"));
        dispatch(setIndex(forms[errorIndex].index));
      } else {
        dispatch(apiSetAlert("لیست انبارها با موفقیت ثبت شد", "success", !!modalProps));

        if (modalProps) {
          dispatch(appCloseModal());
          dispatch(resetForm());
          if (res) {
            modalProps.onFinish(token, res);
          } else {
            dispatch(modalProps.onFinish(token));
          }
        } else {
          navigate("/inventories");
        }
      }
    }
  };

  if (form.status !== "saved") {
    dispatch(setIndex(form.index));
    dispatch(updateFormStatus("saving"));
    const formData = setWarehouseFormData(form);
    axios
      .post("/warehouses", formData, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        dispatch(updateFormStatus("saved"));
        nextApi(response.data?.warehouse);
      })
      .catch((error) => {
        errorIndex = index;
        dispatch(updateFormStatus("error", error.response.data.message));
        nextApi();
      });
  } else {
    nextApi();
  }
};

export const apiUpdateWarehouse = (warehouseId, form, token, navigate) => (dispatch, getState) => {
  const formData = setWarehouseFormData(form);

  dispatch(appSetSendingRequest(true));
  axios
    .put(`warehouses/${warehouseId}`, formData, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      dispatch(apiSetAlert(response.data.message, "success", false));
      navigate("/inventories");
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiAddWarehousesExcel = (forms, token, callback) => (dispatch, getState) => {
  dispatch(appSetSendingRequest(true));
  apiAddWarehouseExcel(dispatch, forms, token, 0, callback);
};

export const apiAddWarehouseExcel = (dispatch, forms, token, index, callback) => {
  const form = forms[index];

  const nextApi = () => {
    if (index + 1 < forms.length) {
      apiAddWarehouseExcel(dispatch, forms, token, index + 1, callback);
    } else {
      dispatch(appSetSendingRequest(false));
      callback(forms);
    }
  };

  if (form.status !== "saved") {
    form.status = "saving";
    const formData = setWarehouseFormData(form);
    axios
      .post("/warehouses", formData, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        form.status = "saved";
        nextApi();
      })
      .catch((error) => {
        form.status = "error";
        form.error = error.response.data.message;
        nextApi();
      });
  } else {
    nextApi();
  }
};
export const apiGetWarHousesByProductId = ({ productId, callback }) => (dispatch, getState) => {
  const Token = getState().businessReducer.business?.token;
  const url = `warehouses/product/${productId}`
  // dispatch(appSetLoading(true));

  axios.get(url, { headers: { Authorization: `Bearer ${Token}` } }).then(res => {
    // dispatch(appSetLoading(false));
    callback(res.data.data)
  })

}
export const apiWarehouseStock =
  ({ pagination, token, key, params, options, id, sort, search, dynamicColumns, cb, getSupply }) =>
    (dispatch, getState) => {
      let warehouseId = id;
      let url = `warehouses/supply/warehouses`;
      if (key === "inventorySupply" || key === "warehouse") {
        if (!warehouseId) return;
        url = `warehouses/${warehouseId}/supply`;
      }

      options = { ...options, ...getOptionsQuery(pagination, search, sort) };

      dispatch(appSetLoading());
      axios
        .post(url, options, {
          headers: { Authorization: `Bearer ${token}` },
          params,
        })
        .then((response) => {
          let supply = [];
          if (key === "inventorySupply" || key === "warehouse") {
            supply = response.data.productWarehouses ?? response.data.Product_Warehouse;
          } else {
            for (const pw of response.data.productWarehouses) {
              supply.push({
                ...pw,
                supply: [
                  ...pw.warehouses
                ],
              });
            }
          }
          if (pagination && !pagination?.notTable) {
            dispatch(setTableData(supply, response.data.paginate, response.data.sumAmount, response.data.sumAmountFinal));
          }

          if (response.data.warehouses && dynamicColumns) {

            dynamicColumns(response.data.warehouses);
          }

          if (cb) cb(response.data);
          if (getSupply) getSupply(supply);

          dispatch(appSetLoading(false));
        })
        .catch((error) => {
          errorDispatcher(error, dispatch);
        });
    };

export const apiWarehouseShortage =
  ({ pagination, token, key, type, id, sort, search, dynamicColumns, cb }) =>
    (dispatch, getState) => {
      let warehouseId = id;
      if (!warehouseId) return;
      let url = `warehouses/${warehouseId}/shortage`;

      let options = getOptionsQuery(pagination, search, sort);

      dispatch(appSetLoading());
      axios
        .post(url, options, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          let supply = [];
          supply = response.data.Product_Warehouse;

          if (pagination && !pagination?.notTable) {
            dispatch(setTableData(supply, response.data.paginate));
          }

          if (cb) cb(response.data);

          dispatch(appSetLoading(false));
        })
        .catch((error) => {
          errorDispatcher(error, dispatch);
        });
    };

export const apiSetWarehouseHandling =
  ({ data, token, id }, cb) =>
    (dispatch) => {
      dispatch(appSetLoading());
      let req = axios.post;
      let url = "warehouseHandlings";
      if (id) {
        req = axios.put;
        url = "warehouseHandlings/" + id;
      }
      req(url, data, { headers: { Authorization: `Bearer ${token}` } })
        .then((res) => {
          cb && cb(res.data);
          dispatch(appSetLoading(false));
          dispatch(apiSetAlert(res.data.message, "success"));
        })
        .catch((err) => {
          errorDispatcher(err, dispatch);
        });
    };
export const apiGetWarehouseHandlings =
  ({ pagination, token }, cb) =>
    (dispatch) => {
      dispatch(appSetLoading());

      let options = getOptionsQuery(pagination);
      axios
        .get("warehouseHandlings", {
          headers: { Authorization: `Bearer ${token}` },
          params: options,
        })
        .then((res) => {
          cb && cb(res.data);
          const w = res.data.warehouseHandlings;
          const data = w.map((x) => ({
            id: x?.id,
            createdAt: x?.date,
            warehouse: x?.Warehouse?.title,
            description: x?.description,
            status: x?.status === "during" ? "در جریان" : "ثبت نهایی",
            project: x?.Project?.title,
            branch: x?.Branch?.title,
          }));
          dispatch(setTableData(data, res.data.paginate));
          dispatch(appSetLoading(false));
        })
        .catch((err) => {
          errorDispatcher(err, dispatch);
        });
    };

export const apiGetWarehouseHandling =
  ({ token, id }, cb) =>
    (dispatch) => {
      dispatch(appSetLoading());
      axios
        .get(`warehouseHandlings/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          cb && cb(res.data);
          dispatch(appSetLoading(false));
        })
        .catch((err) => {
          errorDispatcher(err, dispatch);
        });
    };

export const apiDeleteWarehouseHandlings = (ids, token, activeTab) => (dispatch) => {
  dispatch(appSetLoading());
  axios
    .delete("warehouseHandlings/multiple/delete", {
      headers: { Authorization: `Bearer ${token}` },
      data: { warehouseHandlingIds: ids },
    })
    .then((res) => {
      dispatch(appSetAlert(res.data.message, "success"));
      dispatch(appSetLoading(false));
    })
    .catch((err) => {
      errorDispatcher(err, dispatch);
    });
};
